const loadedFonts = new Set<string>()

export async function loadFont(
  family: string,
  weight: number,
  path: string
): Promise<void> {
  const fontKey = `${family}-${weight}`
  if (loadedFonts.has(fontKey)) {
    return
  }

  const font = new FontFace(family, `url(${path})`, {
    weight: weight.toString()
  })

  await font.load()
  document.fonts.add(font)
  loadedFonts.add(fontKey)
}
